module.exports = __webpack_public_path__ + "img/02-04-img-06.34b8e9d5.png";